import { defineComponent as _defineComponent } from 'vue'
import { HoursOfWorkListDto } from '@/models/HoursOfWork';
import { VBtn, VCol, VIcon, VRow } from 'vuetify/lib';
import moment from 'moment';
import { computed, useSlots, ref, watch } from 'vue';

enum SlotsName {
  PREPEND = 'prepend',
  APPEND = 'append',
}

type HourPickerModel = { dayIndex: number, hourIndex: number };
interface FpHourPickerProps {
  value?: Date | null;
  cols?: number;
  colsList?: Nullable<HoursOfWorkListDto[]>;
  loading?: boolean;
  leftArrowId?: string;
  rightArrowId?: string;
  availableHourId?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FpHourPicker',
  props: {
    value: null,
    cols: { default: 4 },
    colsList: null,
    loading: { type: Boolean, default: false },
    leftArrowId: { default: '' },
    rightArrowId: { default: '' },
    availableHourId: { default: '' }
  },
  setup(__props: any, { emit: emits }: { emit: ({
  input: (value: Date) => void;
  bufferEnds: () => void;
  bufferStarts: () => void;
  'update:picked-hour': (value: HoursOfWorkListDto) => void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: Date | null, cols: number, colsList?: Nullable<HoursOfWorkListDto[]>, loading: boolean, leftArrowId: string, rightArrowId: string, availableHourId: string }

function subString(value: Nullable<string> = '', numberOfChars: number) {
  return value?.substr(0, numberOfChars) || '';
}

const DAY_FORMAT = 'DD.MM.YYYY';
const HOUR_FORMAT = 'HH:mm';
const BUFFER_THRESHOLD = 3;
const MIN_COL_WIDTH = 110;
const HOURS_FORMAT_LENGTH = 5;

const slots = useSlots();
const hasSlot = (name: string) => {
  return !!slots[name];
};





const page = ref(0);

const rows = computed(() => {
  return props.colsList ? Math.max(...props.colsList.map(x => x.hours?.length || 0)) : 0;
});

const styles = computed(() => ({
  'min-width': `${props.cols * MIN_COL_WIDTH}px`,
}));

const modelRef = computed(() => {
  if (!props.value || !props.colsList) {
    return null;
  }

  const normalizedDayValue = moment(String(props.value)).format(DAY_FORMAT);
  const normalizedHourValue = moment(String(props.value)).format(HOUR_FORMAT);

  const foundDay = props.colsList.find(day => moment(String(day.day)).format(DAY_FORMAT) === normalizedDayValue);
  if (!foundDay || !foundDay.hours) {
    return null;
  }

  const dayIndex = props.colsList.indexOf(foundDay);

  const foundHour = foundDay.hours.find(hour => subString(hour.hour, HOURS_FORMAT_LENGTH) === normalizedHourValue);
  if (!foundHour) {
    return null;
  }

  const hourIndex = foundDay.hours.indexOf(foundHour);
  if (hourIndex === -1) {
    return null;
  }

  return { dayIndex, hourIndex, };
});

const isChecked = (model: HourPickerModel): boolean => {
  const currentModel = modelRef.value;
  return !!currentModel &&
    currentModel.dayIndex === (model.dayIndex + page.value) &&
    currentModel.hourIndex === model.hourIndex;
};

const disabledNextPage = computed(() => {
  return (!!props.colsList && (page.value === props.colsList.length - props.cols)) || props.loading;
});

const nextPage = () => {
  page.value++;

  if (page.value > (props.colsList?.length || 0) - props.cols - BUFFER_THRESHOLD) {
    emits('bufferEnds');
  }
};

const disabledPrevPage = computed(() => {
  return !props.colsList || page.value === 0 || props.loading;
});

const prevPage = () => {
  if (page.value > 0) {
    page.value--;
  } else {
    emits('bufferStarts');
  }
};

const onClick = (model: HourPickerModel) => {
  const col = props.colsList![model.dayIndex + page.value];
  const pickedHour = col.hours![model.hourIndex];
  const [hour, minutes,] = pickedHour.hour.split(':').map(Number);
  const dateObject = new Date(String(col.day));
  dateObject.setHours(hour, minutes);
  emits('input', dateObject);
  emits('update:picked-hour', pickedHour);
};

const filteredColsList = computed(() => {
  return props.colsList?.filter((col, index) => index >= page.value && index < props.cols + page.value) || [];
});

function resetPage(): void {
  page.value = 0;
}

watch(() => props.colsList?.length, (newValue, oldValue) => {
  if (page.value === 0 && oldValue && newValue) {
    page.value += newValue - oldValue - 1;
  }

  // it setting a page to 0 when propsModel changes
  // and choosed date is outside of colsList
  if (oldValue && newValue && oldValue > newValue) {
    resetPage();
  }

  // case when page is totaly of a boundries of a passed list then set it to
  if (page.value >= props?.colsList?.length - 1) {
    resetPage();
  }
});


return { __sfc: true,SlotsName, subString, DAY_FORMAT, HOUR_FORMAT, BUFFER_THRESHOLD, MIN_COL_WIDTH, HOURS_FORMAT_LENGTH, slots, hasSlot, emits, props, page, rows, styles, modelRef, isChecked, disabledNextPage, nextPage, disabledPrevPage, prevPage, onClick, filteredColsList, resetPage, VBtn, VCol, VIcon, VRow }
}

})